import React from "react";

import './ShippingCostsTable.css';
import TablePage from "../../global/Table/TablePage";
import { Box, FormControl, InputLabel, MenuItem, Select, TableCell } from '@mui/material';
import {Layout} from "../../global/Table/TablePageHelpers/LayoutObject";
import {
    DEFAULT_SORT_BY_HEAD_CELL, LIST_SHIPPING_COST_CELLS,
    ROWS_PER_PAGE_LABEL, SHIPPING_COST_PAGE_NAME,
} from '../constants';
import TopToolbar from "../../global/subcomponents/topToolbar/TopToolbar";
import { BACK } from '../../invoices/carrierInvoices/constants';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import SettingsIcon from '@material-ui/icons/Settings';
import { IconButton, TextField, Tooltip } from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';
import { OPTIONS, SHIPPING_COST_INFO } from '../../automationrules/AutomationSettings/constants';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Filter } from '../../global/Table/TablePageHelpers/FilterObject';

class ShippingCostsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableEvents: [],
      isSettingPage: false,
      selectedStatus: false,
      otherCostStatus: false,
      productCostFromDate: '1',
      boxCostFromDate: '1',
      ftlCostFromDate: '',
      otherCostText: '0.00',
      percentageCostText: '',
      dollarCostText: '',
      referralFeeText: '15',
      boxAverageCost: '',
      currencyRates:[],
      defaultCurrency: "",
      shippingCostFromDate: '1',
      locations: [],
      selectedLocation: "All",
      selectedCurrency: "All",
      selectedCarrier: "All",
      selectedCarrierLocation: "All"
    };
  }


  componentDidMount() {
    this.updateState()
    this.updateLocations(this.props.availableLocations);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.automationSettings !== this.props.automationSettings) {
            this.updateState()
        }

        if (prevProps.availableLocations !== this.props.availableLocations) {
           this.updateLocations(this.props.availableLocations);
        }
  }

  updateLocations = (availableLocations) => {
    if (!availableLocations) return;
    const locationNames = [
      'All',
      ...availableLocations
        .filter(loc => loc.enabled === true)
        .map(loc => loc.name)
    ];
    this.setState({ locations: locationNames });
  }

  setIsSettingPage = (bool) => {
    this.setState({ isSettingPage: bool });
  };

  updateHandler = () => {
        let inputObject = {};
        let boxDateRange = {};
        let ftlDateRange = {};
        let productDateRange = {};
        let shippingDateRange = {};
        productDateRange["fromDate"] = this.state.productCostFromDate;
        boxDateRange["fromDate"] = this.state.boxCostFromDate;
        ftlDateRange["fromDate"] = this.state.ftlCostFromDate;
        shippingDateRange["fromDate"] = this.state.shippingCostFromDate;
        inputObject["accountForProfitOrLoss"] = this.state.selectedStatus;
        inputObject["productCostDateRange"] = productDateRange;
        inputObject["boxCostDateRange"] = boxDateRange;
        inputObject["ftlCostDateRange"] = ftlDateRange;
        inputObject["shippingCostDateRange"] = shippingDateRange;
        inputObject["otherCosts"] = this.state.otherCostStatus;
        inputObject["otherCostText"] = this.state.otherCostText;
        inputObject["referralFee"] = this.state.referralFeeText;
        inputObject["currencyRates"] = this.state.currencyRates;
        inputObject["defaultCurrency"] = this.state.defaultCurrency;
        this.props.updateCompany({
            companyId: this.props.user.company,
            automationSetting: inputObject,
        });
    }

  updateState = () => {
        this.setState({
            selectedStatus: this.props?.automationSettings?.accountForProfitOrLoss === undefined ? false : this.props?.automationSettings?.accountForProfitOrLoss,
            otherCostStatus: this.props?.automationSettings?.otherCosts === undefined ? false : this.props?.automationSettings?.otherCosts,
            productCostFromDate: this.props?.automationSettings?.productCostDateRange?.fromDate === undefined ? "1" : this.props?.automationSettings?.productCostDateRange?.fromDate,
            boxCostFromDate: this.props?.automationSettings?.boxCostDateRange?.fromDate === undefined ? "1" : this.props?.automationSettings?.boxCostDateRange?.fromDate,
            ftlCostFromDate: this.props?.automationSettings?.ftlCostDateRange?.fromDate === undefined ? "" : this.props?.automationSettings?.ftlCostDateRange?.fromDate,
            shippingCostFromDate: this.props?.automationSettings?.shippingCostDateRange?.fromDate === undefined ? "" : this.props?.automationSettings?.shippingCostDateRange?.fromDate,
            otherCostText: this.props?.automationSettings?.otherCostText === undefined ? "0.00" : this.props.automationSettings?.otherCostText,
            referralFeeText: this.props?.automationSettings?.referralFee === undefined ? "15" : this.props?.automationSettings?.referralFee,
            currencyRates: this.props?.automationSettings?.currencyRates === undefined ? [] : this.props?.automationSettings?.currencyRates,
            defaultCurrency: this.props?.automationSettings?.defaultCurrency === undefined ? [] : this.props?.automationSettings?.defaultCurrency
        });
    }

  getTableHeaders = () => {
    let headers = [];
    headers.push(Layout.columnHead(null, null, null));
    LIST_SHIPPING_COST_CELLS.forEach((headCell) => {
      headers.push(Layout.columnHead(headCell.label, headCell.id, 'left'));
    });
    return headers;
  };

  tableRow = (row, index) => {
    return (
      <React.Fragment>
        <TableCell />
        <TableCell align="left" style={{ paddingLeft: 5 }}>
            {row?.packaging?.startsWith('Box/') ? row.packaging.slice(4) : row?.packaging}
        </TableCell>
        <TableCell align="left">
          {' '}
          {row?.averageCost
            ? '$' + parseFloat(row?.averageCost.toString()).toFixed(2)
            : ''}{' '}
        </TableCell>
        <TableCell align="left"> {row?.currency} </TableCell>
      </React.Fragment>
    );
  };

  searchStrings = (row) => {
    return [row.packaging, row.averageCost, row.currency, row.carrierName];
  };

  handleShippingDateChange = async (date, fromOrTo) => {
    if (fromOrTo === 'from') {
      await this.setState({
        shippingCostFromDate: date,
      });
    }
    this.updateHandler();
  };

  handleCurrencyChange = (event) => {
        this.setState({ selectedCurrency: event.target.value })
  }

  handleLocationChange = (event) => {
      const newLocation = event.target.value;
      const filteredCarriers = this.getFilteredCarriers().filter(
          c => c.location === newLocation || newLocation === 'All'
      );

      const currentCarrierExists = filteredCarriers.some(
          c => c.value === this.state.selectedCarrier
      );

      this.setState({
          selectedLocation: newLocation,
          selectedCarrier: currentCarrierExists ? this.state.selectedCarrier : 'All',
          selectedCarrierLocation: currentCarrierExists
              ? this.state.selectedCarrierLocation
              : 'All'
      });
  };

  getFilteredCarriers = () => {
    const { selectedCurrency, selectedLocation } = this.state;
    const carriers = this.props.carriers || [];

    const filtered = carriers
      .filter(carrier => {
        if (!carrier.isEnabled) return false;
        if (selectedCurrency !== 'All' && carrier.currencyCode !== selectedCurrency) return false;

        const carrierLocation = carrier?.addresses?.[0]?.name;
        if (selectedLocation !== 'All' && carrierLocation !== selectedLocation) return false;

        return true;
      })
      .map(carrier => {
        const location = carrier?.addresses?.[0]?.name || 'Unknown';
        return {
          label: `${carrier.name} (${location})`,
          value: `${carrier.name} (${location})`,
          name: carrier.name,
          location
        };
      });

    filtered.sort((a, b) => a.value.localeCompare(b.value));

    return [
      { label: 'All', value: 'All', location: 'All' },
      ...filtered
    ];
  };

  handleCarrierChange = (event) => {
    const selected = this.getFilteredCarriers().find(c => c.value === event.target.value);
    this.setState({
      selectedCarrier: selected.name || "All",
      selectedCarrierLocation: selected.location
    });
  };


  userHasAutomationSettingPermission = () => {
       const userRoutes = this.props.user?.routes || []
       return userRoutes.includes('automation-settings')
  }

  render() {

    const currency = ['All','CAD', 'USD']

    const filteredRows = this.props.tableRows.filter((row) => {
        const loc = this.state.selectedLocation;
        const carrier = this.state.selectedCarrier;
        const carrierLoc = this.state.selectedCarrierLocation;
        const curr = this.state.selectedCurrency;

        if (loc === 'All' && carrier === 'All') {
          if (row.type !== 'GLOBAL') return false;
        } else if (loc === 'All' && carrier !== 'All') {
          if (row.type !== 'CARRIER') return false;
          if (row.carrierName !== carrier) return false;
          if (carrierLoc !== 'All' && row.location !== carrierLoc) return false;
        } else if (loc !== 'All' && carrier === 'All') {
          if (row.type !== 'LOCATION' || row.location !== loc) return false;
        } else if (loc !== 'All' && carrier !== 'All') {
          if (row.type !== 'CARRIER' || row.carrierName !== carrier || row.location !== loc) return false;
        }

        if (curr !== 'All' && row.currency !== curr) return false;

        return true;
      });


       const menuItems = [];

        if (this.state.isSettingPage) {
          menuItems.push({
            title: 'Back',
            icon: <KeyboardBackspaceIcon />,
            onClick: () => {
              this.setIsSettingPage(false);
            },
          });
        } else if (this.userHasAutomationSettingPermission()) {
          menuItems.push({
            title: 'Settings',
            icon: <SettingsIcon />,
            onClick: () => {
              this.setIsSettingPage(true);
            },
          });
        }


    return (
      <React.Fragment>
        <TopToolbar
          pageName={
            this.state.isSettingPage ? 'Settings' : SHIPPING_COST_PAGE_NAME
          }
          menuItems={menuItems}
        />
        {this.state.isSettingPage ? (
          <div style={{ marginTop: '24px',marginLeft:'24px' }}>
            <div className="other-margin">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <TextField
                  label="Shipping Cost"
                  InputProps={{
                    disabled: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <Tooltip
                          enterTouchDelay={0}
                          leaveTouchDelay={30000}
                          enterDelay={400}
                          title={
                            <React.Fragment>
                              {SHIPPING_COST_INFO}
                            </React.Fragment>
                          }
                        >
                          <IconButton aria-label="info">
                            <InfoOutlinedIcon
                              variant="outlined"
                              fontSize="small"
                            />
                          </IconButton>
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  InputLabelProps={{ className: 'shipping-label' }}
                  style={{
                    marginBottom: '5px',
                    maxWidth: '175px',
                    minWidth: '175px',
                  }}
                />
              </div>
              <div className="vl"></div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
               <Autocomplete
                  options={OPTIONS}
                  getOptionLabel={(option) => option.label}
                  className="date-box"
                  name="addTag"
                  onChange={(event, value) => {
                    if (value) {
                      this.handleShippingDateChange(value.id, 'from');
                    } else {
                      this.handleShippingDateChange(null, 'from');
                    }
                  }}
                  value={OPTIONS.find(
                    (opt) => opt.id === this.state.shippingCostFromDate
                  ) || null}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Average Over"
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                      name="addTag"
                    />
                  )}
                />
              </div>
            </div>
          </div>
        ) : (<>

          <Box className="box-shipping-cost">

           <FormControl variant="outlined" className="form-control">
              <InputLabel id="currency-label">Location</InputLabel>
              <Select
                className="form-shipping-select"
                labelId="localion-label"
                value={this.state.selectedLocation}
                onChange={this.handleLocationChange}
                label="Location"
              >
                {this.state.locations.map((loc) => (
                  <MenuItem key={loc} value={loc}>
                    {loc}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl variant="outlined" className="form-control">
              <InputLabel id="carrier-label">Carrier</InputLabel>
              <Select
                className="form-shipping-select"
                labelId="carrier-label"
                value={this.state.selectedCarrierLocation === 'All' ? 'All' : `${this.state.selectedCarrier} (${this.state.selectedCarrierLocation})`}
                onChange={this.handleCarrierChange}
                label="Carrier"
              >
                {this.getFilteredCarriers().map((carrier) => (
                  <MenuItem key={carrier.value} value={carrier.value}>
                    {carrier.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl variant="outlined" className="form-control">
              <InputLabel id="currency-label">Currency</InputLabel>
              <Select
                className="form-shipping-select"
                labelId="currency-label"
                value={this.state.selectedCurrency}
                onChange={this.handleCurrencyChange}
                label="Currency"
              >
                {currency.map((currency) => (
                  <MenuItem key={currency} value={currency}>
                    {currency}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <div className="table-page-shipping-cost">
            <TablePage
              tableName="purchaseTable"
              tableRows={filteredRows}
              tableColumnHeads={this.getTableHeaders()}
              tableRow={this.tableRow}
              hasSearchField
              paginationText={ROWS_PER_PAGE_LABEL}
              defaultSortBy={DEFAULT_SORT_BY_HEAD_CELL}
              searchStrings={(row) => LIST_SHIPPING_COST_CELLS.map(column => row[column.id])}
              filters={[
                Filter.createFilter('packaging', (row) => row.packaging, null, Filter.relations.containedBy, true),
                Filter.createFilter('averageCost', (row) => row.averageCost, null, Filter.relations.containedBy, true),
                Filter.createFilter('currency', (row) => row.currency, null, Filter.relations.containedBy, true),
                Filter.createFilter('location', (row) => row.location, null, Filter.relations.containedBy, true),
              ]}
              applyFilterDropdownChangesImmediately
            />
          </div>
          </>


          )}
          </React.Fragment>
        );
        }
  }


export default ShippingCostsTable;